import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import { DOC_TYPES_KEYS, NAME_TYPE, SYMBOL_RANGE } from "../../../constants"

const CardHeader = ({ data, type }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div className='tw-flex tw-items-center tw-gap-2'>
      <FontAwesomeIcon
        className='tw-h-6 tw-w-6 tw-text-secondary'
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        icon={["fal", DOC_TYPES_KEYS(t)[data.tipoDocumento].icon]}
      />
      {data.todosLosRangos ? (
        <p className='tw-m-0 tw-font-medium'>
          {" "}
          {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... */}
          {NAME_TYPE[type] === NAME_TYPE.Factura
            ? t("documentos.validar.idView.allMLabel")
            : t("documentos.validar.idView.allFLabel")}{" "}
          {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type  because expre... */}
          <span className='tw-text-primary'>{NAME_TYPE[type]}</span>
        </p>
      ) : (
        <p className='tw-m-0 tw-font-medium'>
          <span className='tw-text-primary'>{type}</span>
          {t("flujoAprobaciones.fromLabel")}
          {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... */}
          {SYMBOL_RANGE[data.rango?.operador]}{" "}
          {data.rango?.valorInferior?.toLocaleString("es-ES", {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      )}
    </div>
  )
}

export default CardHeader
